module.exports = __webpack_public_path__ + "media/images/shark/BlueOcean_2-ee5a7386525f5d35511b503ffb41a9e7.jpg";